import * as Tone from 'tone';
import MidiNode from '../core/MidiNode';
class Instrument {
    constructor() {
        this.inputNode = new MidiNode();
        this.outputGain = new Tone.Gain(0, "decibels");
        this.inputNode.triggerAttack = this.triggerAttack.bind(this);
        this.inputNode.triggerRelease = this.triggerRelease.bind(this);
    }
    input() { return this.inputNode; }
    output() { return this.outputGain; }
}
export default Instrument;
//# sourceMappingURL=Instrument.js.map